import React from "react";
import CompanyTeamsTable from "./CompanyTeamsTable";

const CompanyTeams = () => {
  return (
    <div>
      <CompanyTeamsTable />
    </div>
  );
};

export default CompanyTeams;
